import React, { useState, useEffect } from 'react';
import './WordReveal.css';

/**
 * Reveals text word-by-word with a soft fade-in animation.
 * Each word appears quickly with a brief opacity transition.
 *
 * @param {string} text - The full text to reveal
 * @param {number} delay - Milliseconds between each word (default: 40)
 * @param {function} onComplete - Called when all words are revealed
 */
const WordReveal = ({ text, delay = 40, onComplete }) => {
  const [visibleCount, setVisibleCount] = useState(0);
  const words = text ? text.split(/(\s+)/) : []; // preserve whitespace

  useEffect(() => {
    if (visibleCount < words.length) {
      const timeout = setTimeout(() => {
        setVisibleCount(prev => prev + 1);
      }, delay);
      return () => clearTimeout(timeout);
    } else if (visibleCount > 0 && onComplete) {
      onComplete();
    }
  }, [visibleCount, words.length, delay, onComplete]);

  // Reset when text changes
  useEffect(() => {
    setVisibleCount(0);
  }, [text]);

  return (
    <span>
      {words.map((word, index) => (
        <span
          key={index}
          className={index < visibleCount ? 'word-visible' : 'word-hidden'}
        >
          {word}
        </span>
      ))}
    </span>
  );
};

export default WordReveal;
